module.exports = __webpack_public_path__ + "static/apple-icon-180x180-52e7ff575c1e1abf5cef7cc82755dacf.png";